import { defineMessages } from 'react-intl';

export default defineMessages({
  timeslot: {
    id: 'booking.summary.code.timeslot',
    defaultMessage: '{start} - {end}',
  },
  code: {
    id: 'booking.summary.card.code',
    defaultMessage: 'Booking code',
  },
  total: {
    id: 'booking.summary.card.total',
    defaultMessage: 'Total (USD)',
  },
  amount: {
    id: 'booking.summary.card.amount',
    defaultMessage: '${totalAmount}', // eslint-disable-line
  },
});
